var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { alias, deserialize, list, map, object, primitive } from '../../../utils/serializr/serializr';
import { disgardEmptyAspects } from '../../../utils/serializr/schema/specific/actorStore/disgardEmptyAspects';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { runtime } from '../../runtime/Runtime';
export class ActorStore {
    parent;
    actorManualStates = new Map();
    tags;
    aspects = runtime.runtimePermissions.hasEditFunctionality ? observable.map() : new Map();
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    static fromSerialized(ser = {}) {
        return deserialize(ActorStore, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                aspects: withDefault(disgardEmptyAspects(map(object(runtime.class.Aspect, {
                    parentDepth: 2,
                }))), {}),
                tags: alias('roles', withDefault(list(primitive), [])),
            },
        };
    }
}
__decorate([
    editable()
], ActorStore.prototype, "actorManualStates", void 0);
__decorate([
    editable('shallow')
], ActorStore.prototype, "tags", void 0);
__decorate([
    editable('shallow')
], ActorStore.prototype, "aspects", void 0);
__decorate([
    memoize
], ActorStore, "serializeInfo", null);
